import React, { useState, Suspense } from "react";
import ReCAPTCHA from 'react-google-recaptcha';
import { Typography, TextField, Button, Box } from "@mui/material";
import SetLoading from "../loading/setLoading";
import RecoverPasswordModal from "../modals/recoveryPassModal";
//import IconReportAutomator from "../../components/";

// Imports para Google Cloud
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";

// Imports para Microsoft Entry
import MicrosoftEntraButton from "../buttons/microsoftButton";
import AppleIdButton from "../buttons/appleButton";

function CardLogin({ systemData, loginUser, launchErrorModal }) {
    /** CREDENTIALS */
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    /** CONST */
    //Key Google Console
    const gcApiClientId = process.env.REACT_APP_GOOGLE_CONSOLE_SITE_KEY;
    //Key Captcha
    const gcSitekey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
    //Key Microsoft Entra
    const msAppId = process.env.REACT_APP_MICROSOFT_LOGIN_SITE_KEY;

    const [recoverPasswordModalVisible, setRecoverPasswordModalVisible] = useState(false);
    const [allowCaptcha, setAllowCaptcha] = useState(false)

    async function handleSubmit(event) {
        event.preventDefault();
        if (systemData.pass_recaptcha_google && !allowCaptcha) {
            launchErrorModal(400, 'Debe resolver el catpcha')
        } else {
            loginUser(username, password, 'LDAP');
        }
    }

    /** Funciones para recuperar contraseña */
    async function recoverPassword() {
        setRecoverPasswordModalVisible(true)
    }

    /** Funciones para ReCaptcha */
    async function handleReCaptchaChange(token) {
        if (token)
            setAllowCaptcha(true)
        else {

        }
    }

    /** Funcion para Google CLoud */
    async function googleLoginUser(credential) {
        loginUser(credential, 'defaultpass', 'GC')
    }

    return (
        <>
            <Box className="custom-login-card col-lg-4 col-md-6 col-sm-9 col-11 kiwox-panel shadow d-flex flex-column align-items-center">
                <div className="pb-4">
                    <img src={systemData.entry_logo} alt="report-automator" />
                </div>
                {/* ------------------------------ START TEXTO EN LOGIN EDITABLE ------------------------------ */}
                <Typography className="fs-5 mb-3 login-title">{systemData.login_title}</Typography>
                {/* ------------------------------ END TEXTO EN LOGIN EDITABLE ------------------------------ */}
                <form className="box-form" onSubmit={handleSubmit}>
                    {/** Campo username */}
                    {systemData.pass_auth &&
                        <TextField
                            className="form-username"
                            required
                            id="username"
                            label="Usuario"
                            name="username"
                            type="text"
                            autoFocus
                            value={username}
                            onChange={(event) => setUsername(event.target.value)}
                            size="small"
                            InputLabelProps={{ shrink: true }}
                        />
                    }
                    {/** Campo password */}
                    {systemData.pass_auth &&
                        <TextField
                            className="form-password mb-1"
                            required
                            id="password"
                            label="Contraseña"
                            name="password"
                            type="password"
                            value={password}
                            onChange={(event) => setPassword(event.target.value)}
                            size="small"
                            InputLabelProps={{ shrink: true }}
                        />
                    }

                    {/** Captcha v2 */}
                    {(systemData.pass_auth && systemData.pass_recaptcha_google) &&
                        <ReCAPTCHA
                            className="mt-4"
                            sitekey={gcSitekey}
                            onChange={handleReCaptchaChange}
                        />
                    }
                    {/** Captcha v3 */}
                    {/** 
                        <GoogleReCaptchaProvider reCaptchaKey={gcSitekey}>
                            <GoogleReCaptcha
                                onVerify={handleVerifyCaptcha}
                                refreshReCaptcha={refreshReCaptcha}
                            />
                        </GoogleReCaptchaProvider>
                     */}

                    {/** Botón pass recovery */}
                    {(systemData.pass_auth && systemData.pass_recovery) &&
                        <Button className="link-primary btn-recover" onClick={recoverPassword}>
                            ¿Olvidó su contraseña?
                        </Button>
                    }

                    {/** Botón login */}
                    {systemData.pass_auth &&
                        <Button className="btn-principal col-7 mt-4" type="submit">
                            Iniciar sesión
                        </Button>
                    }

                    {/** Botón Google Auth */}
                    {systemData.google_auth &&
                        <Box className="mt-4">
                            <GoogleOAuthProvider className="btn-principal" clientId={gcApiClientId}>
                                <GoogleLogin
                                    onSuccess={credentialResponse => {
                                        googleLoginUser(credentialResponse)
                                    }}
                                    onError={() =>
                                        launchErrorModal('400', "Algo ha ocurrido al intentar conectar con Google")
                                    }
                                />
                            </GoogleOAuthProvider>
                        </Box>
                    }

                    {/** Botón Microsoft Entra */}
                    {systemData.microsoft_auth &&
                        <Box className="mt-4">
                            <MicrosoftEntraButton
                                onSuccess={(response) =>
                                    loginUser(response.account.username, 'defaultpass', 'ME')
                                }
                                onError={() =>
                                    launchErrorModal('400', "Algo ha ocurrido al intentar conectar con Microsoft")
                                }
                                msClient={msAppId}
                            />
                        </Box>
                    }

                    {/** Botón Apple id */}
                    {systemData.apple_idms_auth &&
                        <Box className="mt-4">
                            <AppleIdButton
                                onSuccess={credentialResponse => {
                                    googleLoginUser(credentialResponse)
                                }}
                                onError={() =>
                                    launchErrorModal('400', "Algo ha ocurrido al intentar conectar con Apple")
                                }
                            />
                        </Box>
                    }
                </form >
            </Box >
            <Suspense fallback={<SetLoading />}>
                {recoverPasswordModalVisible && (
                    <RecoverPasswordModal
                        open={recoverPasswordModalVisible}
                        onClose={() =>
                            setRecoverPasswordModalVisible(false)
                        }
                        launchErrorModal={launchErrorModal}
                    />
                )}
            </Suspense>
        </>
    )
}

export default CardLogin;
